import { useMutation, useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { VEHICLE_USER } from "../../../common/query-keys";
import { CmpCarInfoChangeContent } from "../../../components/organisms/CmpPageContent/CmpCarInfoChangeContent";
import { VehicleInfoRegistrationType } from "../../../interface/transportation";
import { request } from "../../../lib/api";
import { UserVehicle } from "../../../types/driver.types";
import { MoreDetailTemplates } from "../../../components/template/MoreDetailTemplates";
import { useEffect, useState } from "react";
import CarManagementModal from "../../../components/molcules/Modal/CarManagementModal";
import { useNavigate } from "react-router";

const CmpCarInfoChangePage = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState<boolean>(false);
  const { register, handleSubmit, setValue, watch, reset } =
    useForm<VehicleInfoRegistrationType>({
      defaultValues: {
        vehicleNumber: "",
        vehicleType: "차종",
        standard: "규격",
        chassis: "샤시",
        vehicleFeatures: [],
      },
    });

  const { data: userVehicleData } = useQuery({
    queryKey: [VEHICLE_USER],
    queryFn: async () => {
      const result = await request<UserVehicle>({
        method: "GET",
        url: VEHICLE_USER,
      });

      return result;
    },
  });

  useEffect(() => {
    if (userVehicleData) {
      reset(userVehicleData);
    }
  }, [userVehicleData]);

  /** 차량정보 POST 함수 */
  const { mutateAsync: postCarInfoDataSource } = useMutation({
    mutationFn: (data: any) => {
      return request<VehicleInfoRegistrationType>({
        method: "POST",
        url: VEHICLE_USER,
        data: data,
      });
    },
    onSuccess: (res) => {
      setIsModal(true);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  /** 데이터 전송 */
  const onSubmit = async (data: VehicleInfoRegistrationType) => {
    try {
      if (data.vehicleType === "차종") {
        alert("차종을 입력하세요.");
        return;
      }
      if (data.standard === "규격") {
        alert("규격을 입력하세요.");
        return;
      }

      if (data.chassis === "샤시") {
        alert("샤시를 입력하세요.");
        return;
      }

      await postCarInfoDataSource(data);
    } catch (error) {
      console.error("권한 요청 에러:", error);
    }
  };

  const onCloseHandler = () => {
    navigate(-1);
  };

  return (
    <>
      <MoreDetailTemplates pageTitle="차량정보 변경">
        <CmpCarInfoChangeContent
          onCloseHandler={onCloseHandler}
          register={register}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          setValue={setValue}
          watch={watch}
        />
      </MoreDetailTemplates>
      {isModal && <CarManagementModal onModalCloseHandler={onCloseHandler} />}
    </>
  );
};

export default CmpCarInfoChangePage;
